export const rafThrottle = (fn) => {
    let scheduled = false;
    let lastArgs = null;
    let lastThis = null;

    return function rafThrottled(...args) {
        lastArgs = args;
        lastThis = this;

        if (scheduled) {
            return;
        }

        scheduled = true;
        window.requestAnimationFrame(() => {
            scheduled = false;
            const argsToApply = lastArgs;
            const thisToApply = lastThis;
            lastArgs = null;
            lastThis = null;
            fn.apply(thisToApply, argsToApply);
        });
    };
};

export const passiveListener = { passive: true };
